<p-button
  label="戻る"
  class="nav-button"
  styleClass="p-button-secondary"
  icon="pi pi-arrow-left"
  iconPos="left"
  (click)="goBack()"></p-button>
<p-button
  label="新規商品アップロード"
  styleClass="p-button-success"
  icon="pi pi-arrow-right"
  iconPos="left"
  (click)="goRegister()"></p-button>
@if (isAdmin) {
  <span>
    <p-button
      label="ストア管理"
      severity="info"
      icon="pi pi-arrow-right"
      iconPos="left"
      (click)="goStoreManage()"></p-button>
  </span>
}
<a id="csv-donwload"></a>

<br />
<br />
<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <form
    [formGroup]="form"
    #f="ngForm">
    <div class="grid">
      <div class="col-12 lg:col-3 xl:col-3">
        <div>
          <b>フリーワード検索</b>
        </div>
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input
            type="text"
            formControlName="keyword"
            id="search-word"
            class="input-full"
            placeholder="検索ワード ASIN, 商品名..."
            pInputText />
        </p-iconfield>
      </div>
      <div class="col-12 lg:col-3 xl:col-3">
        <div>
          <b>注文/仕入日時の絞り込み</b>
        </div>
        <p-datepicker
          formControlName="fromDate"
          [showTime]="true"
          hourFormat="24"
          dateFormat="yy/mm/dd"
          placeholder="登録日from"></p-datepicker>
        〜
        <p-datepicker
          formControlName="toDate"
          [showTime]="true"
          hourFormat="24"
          dateFormat="yy/mm/dd"
          placeholder="登録日to"></p-datepicker>
      </div>
      <div class="col-12 lg:col-3 xl:col-3">
        <div>
          <b>商品の絞り込み</b>
        </div>
        <p-selectbutton
          [options]="sharedOptions"
          formControlName="sharedOption"
          size="small"
          optionLabel="name"></p-selectbutton>
      </div>
      <div class="col-12 lg:col-3 xl:col-3">
        <div>
          <b>仕入れ店舗の絞り込み</b>
        </div>
        <p-select
          [options]="types"
          formControlName="buyingStoreType"
          optionLabel="name"
          [showClear]="true"
          placeholder="カテゴリ"
          filter="true"
          (onChange)="changeType()">
          <ng-template #selectedItem>
            @if (form.value.buyingStoreType) {
              <div>
                <div>{{ form.value.buyingStoreType.name }}</div>
              </div>
            }
          </ng-template>
          <ng-template
            let-type
            #item>
            <div>{{ type.name }}</div>
          </ng-template>
        </p-select>

        <p-select
          [options]="buyingStores"
          formControlName="buyingStore"
          optionLabel="name"
          [showClear]="true"
          placeholder="店舗"
          filter="true">
          <ng-template #selectedItem>
            @if (form.value.buyingStore) {
              <div>
                <div>{{ form.value.buyingStore.name }}</div>
              </div>
            }
          </ng-template>
          <ng-template
            let-buyingStore
            #item>
            <div>{{ buyingStore.name }}</div>
          </ng-template>
        </p-select>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <div>
          <b>アマゾンカテゴリの絞り込み</b>
        </div>
        <p-select
          [options]="amazonCategories"
          formControlName="amazonCategory"
          optionLabel="name"
          [showClear]="true"
          placeholder="カテゴリ"
          filter="true">
          <ng-template #selectedItem>
            @if (form.value.amazonCategory) {
              <div>
                <div>{{ form.value.amazonCategory.name }}</div>
              </div>
            }
          </ng-template>
          <ng-template
            let-category
            #item>
            <div>{{ category.name }}</div>
          </ng-template>
        </p-select>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <span>
          <div>
            <b>登録者の絞り込み</b>
          </div>
          <p-multiselect
            [options]="users"
            formControlName="user"
            optionLabel="displayName"
            [showClear]="true"
            placeholder="登録者"
            filter="true">
            <ng-template
              let-user
              #item>
              <div>{{ user.displayName }}</div>
            </ng-template>
          </p-multiselect>
        </span>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <span>
          <div>
            <b>その他の絞り込み</b>
          </div>
          <p-select
            [options]="otherSettingOptions"
            formControlName="otherSetting"
            optionLabel="name"
            [showClear]="true"
            placeholder="その他絞り込み"
            filter="true">
            <ng-template #selectedItem>
              @if (form.value.otherSetting) {
                <div>
                  <div>{{ form.value.otherSetting.name }}</div>
                </div>
              }
            </ng-template>
            <ng-template
              let-setting
              #item>
              <div>{{ setting.name }}</div>
            </ng-template>
          </p-select>
        </span>
      </div>

      <div class="col-6"></div>

      <div class="col-6 lg:col-2 xl:col-2">
        <p-button
          styleClass="p-button-info"
          label="プライスター検索"
          icon="pi pi-search"
          (onClick)="doSearchPricetar()"></p-button>
      </div>
      <div class="col-6 lg:col-2 xl:col-2">
        <p-button
          severity="warn"
          label="セドリスト検索"
          icon="pi pi-search"
          (onClick)="doSearchSedorist()"></p-button>
      </div>
      <div class="col-12 lg:col-2 xl:col-2">
        <p-button
          styleClass="p-button-success"
          label="両方の検索"
          icon="pi pi-search"
          (onClick)="doSearchMerged()"></p-button>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <div class="p-field-checkbox">
          <p-checkbox
            inputId="hiddenCols"
            [binary]="true"
            (onChange)="hiddenCols($event)"></p-checkbox>
          <label for="hiddenCols">特定の項目を非表示</label>
        </div>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <div class="p-field-checkbox">
          <p-checkbox
            inputId="hiddenUnPublic"
            [binary]="true"
            (onChange)="hiddenUnPublic($event)"></p-checkbox>
          <label for="hiddenUnPublic">非公開項目を非表示</label>
        </div>
      </div>

      <div class="col-6 lg:col-2 xl:col-2">
        <div class="field-checkbox">
          <p-checkbox
            inputId="hideSheetDataProducts"
            [binary]="true"
            (onChange)="onHideSheetDataProductsChange($event)"></p-checkbox>
          <label for="hideSheetDataProducts">ヤマダ/エディオン/ドンキ商品を非表示</label>
        </div>
      </div>
    </div>
  </form>
</p-panel>

@if (hasPricetar()) {
  <div class="table-header-sticky-outer">
    全{{ pricetars.length.toLocaleString() }}件
    <p-table
      #tpricetar
      showGridlines
      [value]="pricetars"
      columnResizeMode="expand"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="selectedPageSize.size"
      class="table-header-sticky">
      <ng-template #caption>
        <div class="p-d-flex">
          <button
            type="button"
            pButton
            iconOnly
            pRipple
            (click)="outputPricetarCsv()"
            class="p-mr-2"
            pTooltip="CSV"
            tooltipPosition="bottom">
            <i
              class="pi pi-download"
              aria-hidden="true"></i>
          </button>
          @if (isAdmin) {
            <button
              type="button"
              pButton
              pRipple
              (click)="outputAllPricetarCsv()"
              class="p-mr-2 p-button-success"
              pTooltip="CSV"
              tooltipPosition="bottom">
              <i
                class="pi pi-download"
                aria-hidden="true"></i>
              全
            </button>
          }
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th width="6%">画像</th>
          @if (isNonoGroup) {
            <th width="6%">画像管理</th>
          }
          <th width="10%">Keepaグラフ</th>
          <th
            width="6%"
            pSortableColumn="asin">
            ASIN
            <p-sorticon field="asin"></p-sorticon>
          </th>
          <th width="6%">JAN</th>
          <th>商品名</th>
          <th
            width="4%"
            pSortableColumn="topCategory">
            カテゴリ
            <p-sorticon field="buyingPrice"></p-sorticon>
          </th>
          <th
            width="4%"
            pSortableColumn="buyingPrice">
            仕入値
            <p-sorticon field="buyingPrice"></p-sorticon>
          </th>
          <th
            width="4%"
            pSortableColumn="sellingPrice">
            売価
            <p-sorticon field="sellingPrice"></p-sorticon>
          </th>
          <th
            width="4%"
            pSortableColumn="profit">
            利益額
            <p-sorticon field="profit"></p-sorticon>
          </th>
          <th
            width="4%"
            pSortableColumn="profitRate">
            利益率
            <p-sorticon field="profitRate"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="8%"
              pSortableColumn="sku"
              class="sku-column">
              SKU
              <p-sorticon field="sku"></p-sorticon>
            </th>
          }
          @if (showColsVal) {
            <th
              width="8%"
              pSortableColumn="orderDate">
              注文日
              <p-sorticon field="orderDate"></p-sorticon>
            </th>
          }
          <th
            width="8%"
            pSortableColumn="buyingStore">
            仕入店舗
            <p-sorticon field="buyingStore"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="5%"
              pSortableColumn="name">
              登録者/設定
              <p-sorticon field="name"></p-sorticon>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template
        #body
        let-pricetar>
        <tr class="{{ getRowStyleWithSheetData(pricetar.isPublic, pricetar.sheetData) }}">
          <td>
            <a
              href="https://www.amazon.co.jp/dp/{{ pricetar.asin }}"
              target="_blank">
              <img
                src="{{ pricetar.imageUrl }}"
                style="width: 50px" />
            </a>
          </td>
          @if (isNonoGroup) {
            <td class="image-manage-cell">
              <div class="product-images-inline">
                @for (img of sortedImages(pricetar.images); track img) {
                  <span
                    class="inline-thumb-wrapper"
                    (mouseenter)="opThumb.show($event)"
                    (mouseleave)="opThumb.hide()">
                    <img
                      [src]="img.url"
                      referrerpolicy="no-referrer"
                      width="50"
                      height="50"
                      [alt]="pricetar.productName + 'の画像'"
                      class="inline-thumb"
                      (click)="openPricetarImages(pricetar)" />
                  </span>
                  <p-popover
                    #opThumb
                    [dismissable]="false">
                    <div class="inline-thumb-large-container">
                      <img
                        [src]="img.url"
                        referrerpolicy="no-referrer"
                        class="inline-thumb-large"
                        [alt]="pricetar.productName + 'の画像'" />
                    </div>
                  </p-popover>
                }
              </div>
              <button
                pButton
                type="button"
                class="p-button-text p-button-sm"
                pTooltip="商品画像"
                (click)="openPricetarImages(pricetar)">
                <i
                  class="pi pi-images"
                  aria-hidden="true"></i>
                {{ canEdit(pricetar.email) ? '管理' : (pricetar.images?.length || 0) + '枚' }}
              </button>
            </td>
          }
          <td>
            <app-keepa-graph [asin]="pricetar.asin"></app-keepa-graph>
          </td>
          <td>{{ pricetar.asin }}</td>
          <td>
            {{ pricetar.jan }}
            @if (getSheetDataBadges(pricetar.sheetData).length > 0) {
              <div class="sheet-data-badges">
                @for (badge of getSheetDataBadges(pricetar.sheetData); track trackByBadge($index, badge)) {
                  <p-badge
                    [value]="badge.label"
                    [severity]="badge.severity"
                    [title]="'ID: ' + badge.id + ' (クリックで詳細表示)'"
                    style="margin-right: 4px; margin-top: 2px; font-size: 10px; cursor: pointer"
                    (click)="handleBadgeClick(badge, $event)"></p-badge>
                }
              </div>
            }
          </td>
          <td class="wrap-text-cell product-name-cell">
            {{ pricetar.productName }}
            @if (showColsVal) {
              <div class="badges-container">
                <p-badge [value]="pricetar.deliveryRoute"></p-badge>
                @if (pricetar.memo) {
                  <p-badge
                    pTooltip="{{ pricetar.memo }}"
                    tooltipPosition="left"
                    value="メモ"
                    severity="warning"></p-badge>
                }
                @if (pricetar.ipMemo) {
                  <p-badge
                    pTooltip="{{ pricetar.ipMemo }}"
                    tooltipPosition="left"
                    value="知財・真贋"
                    severity="info"></p-badge>
                }
                @if (pricetar.isPriceDownInCacheRegister) {
                  <p-badge
                    value="レジ落ち"
                    severity="success"></p-badge>
                }
                @if (pricetar.isSleeped) {
                  <p-badge
                    value="寝かせ"
                    severity="danger"></p-badge>
                }
                @if (pricetar.isPriceNegotiation) {
                  <p-badge
                    value="価格交渉"
                    severity="warning"></p-badge>
                }
              </div>
            }
          </td>
          <td>{{ pricetar.topCategory }}</td>
          <td>
            {{ pricetar.buyingPrice && pricetar.buyingPrice.toLocaleString() }}
          </td>
          <td>{{ pricetar.sellingPrice.toLocaleString() }}</td>
          <td>
            <span [ngStyle]="{ color: pricetar.profit < 0 ? 'red' : 'blue' }">
              {{ pricetar.profit.toLocaleString() }}
            </span>
          </td>
          <td>
            <span [ngStyle]="{ color: pricetar.profit < 0 ? 'red' : 'blue' }">
              {{ pricetar.profitRate | percent: '1.1' }}
            </span>
          </td>
          @if (showColsVal) {
            <td class="sku-cell">
              {{ pricetar.sku }}
            </td>
          }
          @if (showColsVal) {
            <td>{{ pricetar.orderDate | japanDate }}</td>
          }
          <td class="wrap-text-cell">
            @if (!pricetar.isEditing) {
              <div>
                {{ pricetar.buyingStore }}
                @if (canEdit(pricetar.email)) {
                  <span>
                    <i
                      class="pi pi-cog clickable"
                      (click)="openIdModal(opPricetar, $event, pricetar.id)"></i>
                    @if (hasLastStore()) {
                      <div>
                        <button
                          pButton
                          type="button"
                          class="p-button-sm p-button-rounded"
                          (click)="updateSamePricetarStore(lastBuyingStore, pricetar.id)">
                          same
                        </button>
                      </div>
                    }
                  </span>
                }
              </div>
            }
            @if (pricetar.isEditing) {
              <div></div>
            }
          </td>
          @if (showColsVal) {
            <td class="wrap-text-cell">
              <span>{{ pricetar.name }}</span>
              @if (canSetting(pricetar.email)) {
                <div>
                  <i
                    class="pi pi-cog clickable"
                    style="margin-bottom: 8px; display: block; padding-bottom: 8px; border-bottom: 1px solid #ddd"
                    (click)="openPricetarModal(pricetar)"></i>
                  <div style="color: red; margin-top: 8px; padding-top: 8px">
                    <i
                      class="pi pi-trash clickable"
                      (click)="doDeletePricetar(pricetar.id, $event)"></i>
                  </div>
                </div>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (hasSedorist()) {
  <div class="table-header-sticky-outer">
    全{{ sedorists.length.toLocaleString() }}件
    <p-table
      #tsedorist
      showGridlines
      [value]="sedorists"
      [paginator]="true"
      [rows]="selectedPageSize.size"
      columnResizeMode="expand"
      [tableStyle]="{ 'min-width': '50rem' }"
      class="table-header-sticky">
      <ng-template #caption>
        <div class="p-d-flex">
          <button
            type="button"
            pButton
            iconOnly
            pRipple
            (click)="outputSedoristCsv()"
            class="p-mr-2"
            pTooltip="CSV"
            tooltipPosition="bottom">
            <i
              class="pi pi-download"
              aria-hidden="true"></i>
          </button>
          @if (isAdmin) {
            <button
              type="button"
              pButton
              pRipple
              (click)="outputAllSedoristCsv()"
              class="p-mr-2 p-button-success"
              pTooltip="CSV"
              tooltipPosition="bottom">
              <i
                class="pi pi-download"
                aria-hidden="true"></i>
              全
            </button>
          }
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th width="7%">画像</th>
          @if (isNonoGroup) {
            <th width="6%">画像管理</th>
          }
          <th width="10%">Keepaグラフ</th>
          <th
            width="7%"
            pSortableColumn="asin">
            ASIN
            <p-sorticon field="asin"></p-sorticon>
          </th>
          <th width="7%">JAN</th>
          <th>商品名</th>
          <th
            width="5%"
            pSortableColumn="topCategory">
            カテゴリ
            <p-sorticon field="topCategory"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="buyingPrice">
            仕入値
            <p-sorticon field="buyingPrice"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="sellingPrice">
            出品予定価格
            <p-sorticon field="sellingPrice"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="profit">
            利益額
            <p-sorticon field="profit"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="profitRate">
            利益率
            <p-sorticon field="profitRate"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="6%"
              pSortableColumn="sku"
              class="sku-column">
              SKU
              <p-sorticon field="buyingDate"></p-sorticon>
            </th>
          }
          @if (showColsVal) {
            <th
              width="7%"
              pSortableColumn="buyingDate">
              仕入日
              <p-sorticon field="buyingDate"></p-sorticon>
            </th>
          }
          <th
            width="8%"
            pSortableColumn="buyingStore">
            仕入店舗
            <p-sorticon field="buyingStore"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="5%"
              pSortableColumn="name">
              登録者/設定
              <p-sorticon field="buyingStore"></p-sorticon>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template
        #body
        let-sedorist>
        <tr class="{{ getRowStyleWithSheetData(sedorist.isPublic, sedorist.sheetData) }}">
          <td>
            <a
              href="https://www.amazon.co.jp/dp/{{ sedorist.asin }}"
              target="_blank">
              <img
                src="{{ sedorist.imageUrl }}"
                style="width: 50px" />
            </a>
          </td>
          @if (isNonoGroup) {
            <td class="image-manage-cell">
              <div class="product-images-inline">
                @for (img of sortedImages(sedorist.images); track img) {
                  <span
                    class="inline-thumb-wrapper"
                    (mouseenter)="opThumb.show($event)"
                    (mouseleave)="opThumb.hide()">
                    <img
                      [src]="img.url"
                      referrerpolicy="no-referrer"
                      width="50"
                      height="50"
                      [alt]="sedorist.productName + 'の画像'"
                      class="inline-thumb"
                      (click)="openSedoristImages(sedorist)" />
                  </span>
                  <p-popover
                    #opThumb
                    [dismissable]="false">
                    <div class="inline-thumb-large-container">
                      <img
                        [src]="img.url"
                        referrerpolicy="no-referrer"
                        class="inline-thumb-large"
                        [alt]="sedorist.productName + 'の画像'" />
                    </div>
                  </p-popover>
                }
              </div>
              <button
                pButton
                type="button"
                class="p-button-text p-button-sm"
                pTooltip="商品画像"
                (click)="openSedoristImages(sedorist)">
                <i
                  class="pi pi-images"
                  aria-hidden="true"></i>
                {{ canEdit(sedorist.email) ? '管理' : (sedorist.images?.length || 0) + '枚' }}
              </button>
            </td>
          }
          <td>
            <app-keepa-graph [asin]="sedorist.asin"></app-keepa-graph>
          </td>
          <td>{{ sedorist.asin }}</td>
          <td>
            {{ sedorist.jan }}
            @if (getSheetDataBadges(sedorist.sheetData).length > 0) {
              <div class="sheet-data-badges">
                @for (badge of getSheetDataBadges(sedorist.sheetData); track trackByBadge($index, badge)) {
                  <p-badge
                    [value]="badge.label"
                    [severity]="badge.severity"
                    [title]="'ID: ' + badge.id + ' (クリックで詳細表示)'"
                    style="margin-right: 4px; margin-top: 2px; font-size: 10px; cursor: pointer"
                    (click)="
                      onBadgeClick(
                        badge.label === 'ヤマダ' ? 'yamada' : badge.label === 'エディオン' ? 'edion' : 'donki',
                        badge.id,
                        $event
                      )
                    "></p-badge>
                }
              </div>
            }
          </td>
          <td class="wrap-text-cell product-name-cell">
            {{ sedorist.productName }}
            @if (showColsVal) {
              <div class="badges-container">
                <p-badge [value]="sedorist.deliveryRoute"></p-badge>
                @if (sedorist.memo) {
                  <p-badge
                    pTooltip="{{ sedorist.memo }}"
                    tooltipPosition="left"
                    value="メモ"
                    severity="warning"></p-badge>
                }
                @if (sedorist.ipMemo) {
                  <p-badge
                    pTooltip="{{ sedorist.ipMemo }}"
                    tooltipPosition="left"
                    value="知財・真贋"
                    severity="info"></p-badge>
                }
                @if (sedorist.isPriceDownInCacheRegister) {
                  <p-badge
                    value="レジ落ち"
                    severity="success"></p-badge>
                }
                @if (sedorist.isSleeped) {
                  <p-badge
                    value="寝かせ"
                    severity="danger"></p-badge>
                }
                @if (sedorist.isPriceNegotiation) {
                  <p-badge
                    value="価格交渉"
                    severity="warning"></p-badge>
                }
              </div>
            }
          </td>
          <td>{{ sedorist.topCategory }}</td>
          <td>{{ sedorist.buyingPrice.toLocaleString() }}</td>
          <td>{{ sedorist.sellingPrice.toLocaleString() }}</td>
          <td>
            <span [ngStyle]="{ color: sedorist.profit < 0 ? 'red' : 'blue' }">
              {{ sedorist.profit.toLocaleString() }}
            </span>
          </td>
          <td>
            <span [ngStyle]="{ color: sedorist.profit < 0 ? 'red' : 'blue' }">
              {{ sedorist.profitRate | percent: '1.1' }}
            </span>
          </td>
          @if (showColsVal) {
            <td class="sku-cell">
              {{ sedorist.sku }}
            </td>
          }
          @if (showColsVal) {
            <td>{{ sedorist.buyingDate | japanDate }}</td>
          }
          <td class="wrap-text-cell">
            @if (!sedorist.isEditing) {
              <div>
                {{ sedorist.buyingStore }}
                @if (canEdit(sedorist.email)) {
                  <span>
                    <i
                      class="pi pi-cog clickable"
                      (click)="openIdModal(opSedorist, $event, sedorist.id)"></i>
                    @if (hasLastStore()) {
                      <div>
                        <button
                          pButton
                          type="button"
                          class="p-button-sm p-button-rounded"
                          (click)="updateSameSedoristStore(lastBuyingStore, sedorist.id)">
                          same
                        </button>
                      </div>
                    }
                  </span>
                }
              </div>
            }
            @if (sedorist.isEditing) {
              <div></div>
            }
          </td>
          @if (showColsVal) {
            <td class="wrap-text-cell">
              <span>{{ sedorist.name }}</span>
              @if (canSetting(sedorist.email)) {
                <div>
                  <i
                    class="pi pi-cog clickable"
                    style="margin-bottom: 8px; display: block; padding-bottom: 8px; border-bottom: 1px solid #ddd"
                    (click)="openSedoristModal(sedorist)"></i>
                  <div style="color: red; margin-top: 8px; padding-top: 8px">
                    <i
                      class="pi pi-trash clickable"
                      (click)="doDeleteSedorist(sedorist.id, $event)"></i>
                  </div>
                </div>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (hasMerged()) {
  <div class="table-header-sticky-outer">
    全{{ mergedList.length.toLocaleString() }}件
    <p-table
      #tmerged
      showGridlines
      [value]="mergedList"
      [(selection)]="selectedMergeds"
      [paginator]="true"
      [rows]="selectedPageSize.size"
      columnResizeMode="expand"
      [tableStyle]="{ 'min-width': '50rem' }"
      class="table-header-sticky">
      <ng-template #caption>
        <div class="p-d-flex">
          <button
            type="button"
            pButton
            iconOnly
            pRipple
            (click)="outputMergedCsv()"
            class="p-mr-2"
            pTooltip="CSV"
            tooltipPosition="bottom">
            <i
              class="pi pi-download"
              aria-hidden="true"></i>
          </button>
          @if (isAdmin) {
            <button
              type="button"
              pButton
              pRipple
              (click)="outputAllMergedCsv()"
              class="p-mr-2 p-button-success"
              pTooltip="CSV"
              tooltipPosition="bottom">
              <i
                class="pi pi-download"
                aria-hidden="true"></i>
              全
            </button>
          }
        </div>
        @if (selectedMergeds.length > 0) {
          <div class="bulk-action-bar">
            <span class="bulk-count">{{ selectedMergeds.length }}件選択中</span>
            <button
              type="button"
              pButton
              class="p-button-sm"
              (click)="opBulkStore.toggle($event)">
              <i
                class="pi pi-shop"
                aria-hidden="true"></i>
              仕入店舗を一括設定
            </button>
            <span class="bulk-memo-group">
              <input
                type="text"
                pInputText
                class="p-inputtext-sm"
                placeholder="メモを入力"
                [(ngModel)]="bulkMemo" />
              <button
                type="button"
                pButton
                class="p-button-sm"
                [disabled]="!bulkMemo"
                (click)="applyMemoToSelected()">
                <i
                  class="pi pi-pencil"
                  aria-hidden="true"></i>
                メモを一括設定
              </button>
            </span>
            <button
              type="button"
              pButton
              class="p-button-sm p-button-secondary p-button-text"
              (click)="clearMergedSelection()">
              <i
                class="pi pi-times"
                aria-hidden="true"></i>
              選択解除
            </button>
          </div>
        }
      </ng-template>
      <ng-template #header>
        <tr>
          <th
            width="3%"
            class="checkbox-column">
            <p-tableheadercheckbox></p-tableheadercheckbox>
          </th>
          <th width="6%">画像</th>
          @if (isNonoGroup) {
            <th width="6%">画像管理</th>
          }
          <th width="10%">Keepaグラフ</th>
          <th
            width="8%"
            pSortableColumn="asin">
            ASIN
            <p-sorticon field="asin"></p-sorticon>
          </th>
          <th width="8%">JAN</th>
          <th>商品名</th>
          <th
            width="5%"
            pSortableColumn="topCategory">
            カテゴリ
            <p-sorticon field="topCategory"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="buyingPrice">
            仕入値
            <p-sorticon field="buyingPrice"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="sellingPrice">
            出品予定価格
            <p-sorticon field="sellingPrice"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="profit">
            利益額
            <p-sorticon field="profit"></p-sorticon>
          </th>
          <th
            width="5%"
            pSortableColumn="profitRate">
            利益率
            <p-sorticon field="profitRate"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="6%"
              pSortableColumn="sku"
              class="sku-column">
              SKU
              <p-sorticon field="sku"></p-sorticon>
            </th>
          }
          @if (showColsVal) {
            <th
              width="7%"
              pSortableColumn="buyingDate">
              仕入日
              <br />
              注文日
              <p-sorticon field="buyingDate"></p-sorticon>
            </th>
          }
          <th
            width="8%"
            pSortableColumn="buyingStore">
            仕入店舗
            <p-sorticon field="buyingStore"></p-sorticon>
          </th>
          @if (showColsVal) {
            <th
              width="5%"
              pSortableColumn="name">
              登録者/設定
              <p-sorticon field="name"></p-sorticon>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template
        #body
        let-merged>
        <tr class="{{ getRowStyleWithSheetData(merged.isPublic, merged.sheetData) }}">
          <td class="checkbox-column">
            <p-tablecheckbox [value]="merged"></p-tablecheckbox>
          </td>
          <td>
            <a
              href="https://www.amazon.co.jp/dp/{{ merged.asin }}"
              target="_blank">
              <img
                src="{{ merged.imageUrl }}"
                style="width: 50px" />
            </a>
          </td>
          @if (isNonoGroup) {
            <td class="image-manage-cell">
              <div class="product-images-inline">
                @for (img of sortedImages(merged.images); track img) {
                  <span
                    class="inline-thumb-wrapper"
                    (mouseenter)="opThumb.show($event)"
                    (mouseleave)="opThumb.hide()">
                    <img
                      [src]="img.url"
                      referrerpolicy="no-referrer"
                      width="50"
                      height="50"
                      [alt]="merged.productName + 'の画像'"
                      class="inline-thumb"
                      (click)="openMergedImages(merged)" />
                  </span>
                  <p-popover
                    #opThumb
                    [dismissable]="false">
                    <div class="inline-thumb-large-container">
                      <img
                        [src]="img.url"
                        referrerpolicy="no-referrer"
                        class="inline-thumb-large"
                        [alt]="merged.productName + 'の画像'" />
                    </div>
                  </p-popover>
                }
              </div>
              <button
                pButton
                type="button"
                class="p-button-text p-button-sm"
                pTooltip="商品画像"
                (click)="openMergedImages(merged)">
                <i
                  class="pi pi-images"
                  aria-hidden="true"></i>
                {{ canEdit(merged.email) ? '管理' : (merged.images?.length || 0) + '枚' }}
              </button>
            </td>
          }
          <td>
            <app-keepa-graph [asin]="merged.asin"></app-keepa-graph>
          </td>
          <td>{{ merged.asin }}</td>
          <td>
            {{ merged.jan }}
            @if (getSheetDataBadges(merged.sheetData).length > 0) {
              <div class="sheet-data-badges">
                @for (badge of getSheetDataBadges(merged.sheetData); track trackByBadge($index, badge)) {
                  <p-badge
                    [value]="badge.label"
                    [severity]="badge.severity"
                    [title]="'ID: ' + badge.id + ' (クリックで詳細表示)'"
                    style="margin-right: 4px; margin-top: 2px; font-size: 10px; cursor: pointer"
                    (click)="
                      onBadgeClick(
                        badge.label === 'ヤマダ' ? 'yamada' : badge.label === 'エディオン' ? 'edion' : 'donki',
                        badge.id,
                        $event
                      )
                    "></p-badge>
                }
              </div>
            }
          </td>
          <td class="wrap-text-cell product-name-cell">
            {{ merged.productName }}
            @if (showColsVal) {
              <div class="badges-container">
                <p-badge [value]="merged.deliveryRoute"></p-badge>
                @if (merged.memo) {
                  <p-badge
                    pTooltip="{{ merged.memo }}"
                    tooltipPosition="left"
                    value="メモ"
                    severity="warning"></p-badge>
                }
                @if (merged.ipMemo) {
                  <p-badge
                    pTooltip="{{ merged.ipMemo }}"
                    tooltipPosition="left"
                    value="知財・真贋"
                    severity="info"></p-badge>
                }
                @if (merged.isPriceDownInCacheRegister) {
                  <p-badge
                    value="レジ落ち"
                    severity="success"></p-badge>
                }
                @if (merged.isSleeped) {
                  <p-badge
                    value="寝かせ"
                    severity="danger"></p-badge>
                }
                @if (merged.isPriceNegotiation) {
                  <p-badge
                    value="価格交渉"
                    severity="warning"></p-badge>
                }
              </div>
            }
          </td>
          <td>{{ merged.topCategory }}</td>
          <td>{{ merged.buyingPrice.toLocaleString() }}</td>
          <td>{{ merged.sellingPrice.toLocaleString() }}</td>
          <td>
            <span [ngStyle]="{ color: merged.profit < 0 ? 'red' : 'blue' }">
              {{ merged.profit.toLocaleString() }}
            </span>
          </td>
          <td>
            <span [ngStyle]="{ color: merged.profit < 0 ? 'red' : 'blue' }">
              {{ merged.profitRate | percent: '1.1' }}
            </span>
          </td>
          @if (showColsVal) {
            <td class="sku-cell">
              {{ merged.sku }}
            </td>
          }
          @if (showColsVal) {
            <td>{{ merged.buyingDate | japanDate }}</td>
          }
          <td class="wrap-text-cell">
            {{ merged.buyingStore }}
            @if (canEdit(merged.email)) {
              <span>
                <i
                  class="pi pi-cog clickable"
                  (click)="openStoreMerged(opMerged, $event, merged)"></i>
                @if (hasLastStore()) {
                  <div>
                    <button
                      pButton
                      type="button"
                      class="p-button-sm p-button-rounded"
                      (click)="updateSameMergedStore(lastBuyingStore, merged)">
                      same
                    </button>
                  </div>
                }
              </span>
            }
          </td>
          @if (showColsVal) {
            <td class="wrap-text-cell">
              <span>{{ merged.name }}({{ merged.serviceName }})</span>
              @if (merged.serviceName === 'PS') {
                <p-badge
                  severity="success"
                  pTooltip="せどりすと(仕入)とプライスター(売上)の両方に取込済み"
                  tooltipPosition="left"
                  value="仕入✓売却✓" />
              }
              @if (canSetting(merged.email)) {
                <div>
                  <i
                    class="pi pi-cog clickable"
                    style="margin-bottom: 8px; display: block; padding-bottom: 8px; border-bottom: 1px solid #ddd"
                    (click)="openMergedModal(merged)"></i>
                  <div style="color: red; margin-top: 8px; padding-top: 8px">
                    <i
                      class="pi pi-trash clickable"
                      (click)="doDeleteMerged(merged, $event)"></i>
                  </div>
                </div>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}

<p-popover #opSedorist>
  <h5>登録済みの店舗登録</h5>
  <p-select
    [options]="buyingStores"
    [(ngModel)]="selectedBuyingStore"
    optionLabel="name"
    [showClear]="true"
    placeholder="仕入れ店舗"
    filter="true"
    (onChange)="updateSedoristStore(opSedorist)">
    <ng-template #selectedItem>
      @if (selectedBuyingStore) {
        <div>
          <div>{{ selectedBuyingStore.name }}</div>
        </div>
      }
    </ng-template>
    <ng-template
      let-buyingStore
      #item>
      <div class="country-item">
        <div>{{ buyingStore.name }}</div>
      </div>
    </ng-template>
  </p-select>
</p-popover>

<p-popover #opPricetar>
  <p-select
    [options]="buyingStores"
    [(ngModel)]="selectedBuyingStore"
    optionLabel="name"
    [showClear]="true"
    placeholder="仕入れ店舗"
    filter="true"
    (onChange)="updatePricetarStore(opPricetar)">
    <ng-template #selectedItem>
      @if (selectedBuyingStore) {
        <div>
          <div>{{ selectedBuyingStore.name }}</div>
        </div>
      }
    </ng-template>
    <ng-template
      let-buyingStore
      #item>
      <div class="country-item">
        <div>{{ buyingStore.name }}</div>
      </div>
    </ng-template>
  </p-select>
</p-popover>

<p-popover #opBulkStore>
  <h5>選択した{{ selectedMergeds.length }}件に仕入店舗を設定</h5>
  <p-select
    [options]="buyingStores"
    [(ngModel)]="selectedBuyingStore"
    optionLabel="name"
    [showClear]="true"
    placeholder="仕入れ店舗"
    filter="true"
    (onChange)="applyStoreToSelected(opBulkStore)">
    <ng-template #selectedItem>
      @if (selectedBuyingStore) {
        <div>
          <div>{{ selectedBuyingStore.name }}</div>
        </div>
      }
    </ng-template>
    <ng-template
      let-buyingStore
      #item>
      <div class="country-item">
        <div>{{ buyingStore.name }}</div>
      </div>
    </ng-template>
  </p-select>
</p-popover>

<p-popover #opMerged>
  <p-select
    [options]="buyingStores"
    [(ngModel)]="selectedBuyingStore"
    optionLabel="name"
    [showClear]="true"
    placeholder="仕入れ店舗"
    filter="true"
    (onChange)="updateMergedStore(opMerged)">
    <ng-template #selectedItem>
      @if (selectedBuyingStore) {
        <div>
          <div>{{ selectedBuyingStore.name }}</div>
        </div>
      }
    </ng-template>
    <ng-template
      let-buyingStore
      #item>
      <div class="country-item">
        <div>{{ buyingStore.name }}</div>
      </div>
    </ng-template>
  </p-select>
</p-popover>

<p-dialog
  header="商品詳細設定"
  [(visible)]="showPricetarModal"
  [modal]="true"
  [style]="{ width: '50vw', 'min-width': '320px', 'max-width': '90vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #content>
    <div class="grid">
      <div class="col-8">公開設定</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPublic($event)"
          [(ngModel)]="settingPublic"></p-toggleswitch>
      </div>

      <div class="col-8">寝かせ</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsSleeped($event)"
          [(ngModel)]="settingIsSleeped"></p-toggleswitch>
      </div>

      <div class="col-8">レジ落ち</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPriceDownInCacheRegister($event)"
          [(ngModel)]="settingIsPriceDownInCacheRegister"></p-toggleswitch>
      </div>

      <div class="col-8">価格交渉</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPriceNegotiation($event)"
          [(ngModel)]="settingIsPriceNegotiation"></p-toggleswitch>
      </div>

      <div class="col-12">メモ</div>
      <div class="col-12">
        <textarea
          [(ngModel)]="settingMemo"
          rows="5"
          cols="70"
          pInputTextarea
          [autoResize]="true"></textarea>
      </div>

      <div class="col-12">知財・真贋</div>
      <div class="col-12">
        <textarea
          [(ngModel)]="settingIpMemo"
          rows="5"
          cols="70"
          pInputTextarea
          [autoResize]="true"></textarea>
      </div>

      <div class="col-4">
        <!--
        <button
          pButton
          type="button"
          label="この商品を削除"
          class="p-button-sm p-button-danger"
          (click)="doDeletePricetar(selectedColumnId)"
        ></button>
        -->
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <button
          pButton
          type="button"
          class="p-button-sm"
          (click)="updatePricetarSetting()">
          設定する
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="商品詳細設定"
  [(visible)]="showSedoristModal"
  [modal]="true"
  [style]="{ width: '50vw', 'min-width': '320px', 'max-width': '90vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #content>
    <div class="grid">
      <div class="col-8">公開設定</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPublic($event)"
          [(ngModel)]="settingPublic"></p-toggleswitch>
      </div>

      <div class="col-8">寝かせ</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsSleeped($event)"
          [(ngModel)]="settingIsSleeped"></p-toggleswitch>
      </div>

      <div class="col-8">レジ落ち</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPriceDownInCacheRegister($event)"
          [(ngModel)]="settingIsPriceDownInCacheRegister"></p-toggleswitch>
      </div>

      <div class="col-8">価格交渉</div>
      <div class="col-4">
        <p-toggleswitch
          (onChange)="setSettingIsPriceNegotiation($event)"
          [(ngModel)]="settingIsPriceNegotiation"></p-toggleswitch>
      </div>

      <div class="col-12">メモ</div>
      <div class="col-12">
        <textarea
          [(ngModel)]="settingMemo"
          rows="5"
          cols="70"
          pInputTextarea
          [autoResize]="true"></textarea>
      </div>

      <div class="col-12">知財・真贋</div>
      <div class="col-12">
        <textarea
          [(ngModel)]="settingIpMemo"
          rows="5"
          cols="70"
          pInputTextarea
          [autoResize]="true"></textarea>
      </div>

      <div class="col-4">
        <!--
        <button
          pButton
          type="button"
          label="この商品を削除"
          class="p-button-sm p-button-danger"
          (click)="doDeleteSedorist(selectedColumnId)"
        ></button>
        -->
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <button
          pButton
          type="button"
          class="p-button-sm"
          (click)="updateSedoristSetting()">
          設定する
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-confirmpopup></p-confirmpopup>

<!-- 商品詳細ダイアログ -->
<p-dialog
  [header]="
    selectedProductType === 'yamada'
      ? 'ヤマダ電機 商品詳細'
      : selectedProductType === 'edion'
        ? 'エディオン 商品詳細'
        : 'ドンキホーテ 商品詳細'
  "
  [(visible)]="showProductDetailDialog"
  [modal]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [draggable]="true"
  [resizable]="true"
  (onHide)="closeProductDetailDialog()">
  <ng-template #content>
    @if (isLoadingProductDetail) {
      <div class="text-center p-4">
        <i
          class="pi pi-spin pi-spinner"
          style="font-size: 2rem"></i>
        <p>商品詳細を読み込み中...</p>
      </div>
    }

    @if (!isLoadingProductDetail && productDetailData) {
      <div class="product-detail-content">
        <!-- 商品基本情報 -->
        <div class="grid mb-4">
          <div class="col-12 md:col-3">
            <img
              [src]="
                productDetailData.product?.amazonProducts?.[0]?.imageUrl ||
                'https://via.placeholder.com/200x200?text=No+Image'
              "
              alt="商品画像"
              class="w-full max-w-200px border-round shadow-2" />
          </div>
          <div class="col-12 md:col-9">
            <h3 class="mt-0">{{ productDetailData.product?.amazonProducts?.[0]?.name || '商品名なし' }}</h3>
            <p>
              <strong>JAN:</strong>
              {{ productDetailData.product?.jan || 'なし' }}
            </p>
            <p>
              <strong>ASIN:</strong>
              {{ productDetailData.product?.amazonProducts?.[0]?.asin || 'なし' }}
            </p>
            <p>
              <strong>Amazon価格:</strong>
              {{ (productDetailData.product?.amazonProducts?.[0]?.latestPrice || 0).toLocaleString() }}円
            </p>
            @if (selectedProductType === 'yamada') {
              <p>
                <strong>ヤマダ価格:</strong>
                {{ (productDetailData.price || 0).toLocaleString() }}円
              </p>
            }
            @if (selectedProductType === 'edion') {
              <p>
                <strong>POS価格:</strong>
                {{ (productDetailData.posPrice || 0).toLocaleString() }}円
              </p>
            }
            @if (selectedProductType === 'edion') {
              <p>
                <strong>割引価格:</strong>
                {{ (productDetailData.discountPrice || 0).toLocaleString() }}円
              </p>
            }
            <p>
              <strong>総在庫数:</strong>
              {{ productDetailData.totalStocks || 0 }}個
            </p>
            <p>
              <strong>登録日:</strong>
              {{ productDetailData.registrationDate || 'なし' }}
            </p>
            @if (selectedProductType === 'edion' && productDetailData.disposalRank) {
              <p>
                <strong>処分ランク:</strong>
                {{ productDetailData.disposalRank }}
              </p>
            }
          </div>
        </div>
        <!-- 在庫詳細テーブル -->
        <div class="flex justify-content-between align-items-center mb-3">
          <h4 class="m-0">店舗在庫詳細</h4>
          <div class="flex align-items-center gap-2">
            <label
              for="areaFilter"
              class="font-semibold">
              エリア絞り込み:
            </label>
            <p-select
              id="areaFilter"
              [options]="availableAreas"
              [(ngModel)]="selectedArea"
              optionLabel="name"
              optionValue="value"
              placeholder="エリアを選択"
              [style]="{ 'min-width': '200px' }"
              (onChange)="onAreaSelectionChange()"></p-select>
            <small class="text-500">{{ filteredStocks.length }}/{{ productDetailData?.stocks?.length || 0 }}件</small>
          </div>
        </div>
        <p-table
          [value]="filteredStocks"
          [scrollable]="true"
          scrollHeight="400px"
          [tableStyle]="{ 'min-width': '800px' }">
          <ng-template #header>
            <tr>
              <th>エリア</th>
              <th>店舗</th>
              <th>在庫数</th>
              @if (selectedProductType === 'donki') {
                <th>価格</th>
              }
              <th>購入済み</th>
              <th>見つからない</th>
              <th>試無</th>
              <th>メモ</th>
              <th>登録日時</th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-stock>
            <tr>
              <td>{{ stock.store?.area?.name || '-' }}</td>
              <td>{{ stock.store?.name || '-' }}</td>
              <td>{{ stock.stockNum || 0 }}個</td>
              @if (selectedProductType === 'donki') {
                <td>{{ (stock.price || 0).toLocaleString() }}円</td>
              }
              <td>
                @if (stock.operation?.isPurchased) {
                  <span class="text-green-600">
                    <i class="pi pi-check"></i>
                    {{ stock.operation?.purchasedUser?.name || '' }}
                    <br />
                    <small>
                      {{ stock.operation?.purchasedAt | date: 'yyyy/MM/dd HH:mm' }}
                    </small>
                  </span>
                }
                @if (!stock.operation?.isPurchased) {
                  <span class="text-gray-500">未購入</span>
                }
              </td>
              <td>
                @if (stock.operation?.isNotFound) {
                  <span class="text-red-600">
                    <i class="pi pi-times"></i>
                    {{ stock.operation?.notFoundUser?.name || '' }}
                    <br />
                    <small>
                      {{ stock.operation?.notFoundAt | date: 'yyyy/MM/dd HH:mm' }}
                    </small>
                  </span>
                }
                @if (!stock.operation?.isNotFound) {
                  <span class="text-gray-500">-</span>
                }
              </td>
              <td>
                @if (stock.operation?.isDisplay) {
                  <span class="text-blue-600">
                    <i class="pi pi-eye"></i>
                    {{ stock.operation?.displayUser?.name || '' }}
                    <br />
                    <small>
                      {{ stock.operation?.displaySetAt | date: 'yyyy/MM/dd HH:mm' }}
                    </small>
                  </span>
                }
                @if (!stock.operation?.isDisplay) {
                  <span class="text-gray-500">-</span>
                }
              </td>
              <td>
                @if (stock.operation?.memo) {
                  <span>
                    {{ stock.operation?.memo }}
                    <br />
                    <small>
                      {{ stock.operation?.memoUser?.name || '' }} -
                      {{ stock.operation?.memoAddedAt | date: 'yyyy/MM/dd HH:mm' }}
                    </small>
                  </span>
                }
                @if (!stock.operation?.memo) {
                  <span class="text-gray-500">-</span>
                }
              </td>
              <td>{{ stock.createdAt | date: 'yyyy/MM/dd HH:mm' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    @if (!isLoadingProductDetail && !productDetailData) {
      <div class="text-center p-4">
        <p class="text-red-500">商品詳細の取得に失敗しました。</p>
      </div>
    }
  </ng-template>
</p-dialog>

<!-- 画像管理ダイアログ -->
<p-dialog
  header="商品画像"
  [(visible)]="showImageGalleryDialog"
  [modal]="true"
  [style]="{ width: '70vw', 'min-width': '320px', 'max-width': '95vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeImageGalleryDialog()">
  <ng-template #content>
    @if (imageGalleryProductName) {
      <div style="margin-bottom: 12px; color: #555">
        {{ imageGalleryProductName }}
      </div>
    }
    @if (imageGalleryOwnerType && imageGalleryOwnerId) {
      <app-product-image-gallery
        [ownerType]="imageGalleryOwnerType"
        [ownerId]="imageGalleryOwnerId"
        [images]="imageGalleryImages"
        [canEdit]="imageGalleryCanEdit"
        (imagesChanged)="onImagesChanged()"></app-product-image-gallery>
    }
  </ng-template>
</p-dialog>
